import clsx from 'clsx';
import type { StatusDetailWrapperProps } from './StatusDetailWrapper.types';
import { Link } from 'components/Link';
import { AppRoutes } from 'util/urlFactory';

export const StatusDetailWrapper = (props: StatusDetailWrapperProps) => {
  const { children, isCanceled, className } = props;

  const commonStyle = 'inline-flex items-center py-1 px-1.5 text-xs gap-1 mt-2';

  return isCanceled ? (
    <Link
      className={clsx(commonStyle, className, 'underline')}
      href={AppRoutes.EMPLOYER_INTERVIEWS}
    >
      {children}
    </Link>
  ) : (
    <span className={clsx(commonStyle, className)}>{children}</span>
  );
};

StatusDetailWrapper.displayName = 'StatusDetailWrapper';
